import { request as umiRequest } from '@umijs/max';
import { BizAppConfig } from 'config/application.manifest';
import type { ApiRequestOptions } from './bff/types/common';

type ScopedRequestOptions = ApiRequestOptions;

export const createRequest = (baseURL?: string) => {
  const scopedBaseURL = baseURL ?? BizAppConfig.appApiUrl ?? '';
  return <T = unknown>(url: string, options?: ScopedRequestOptions) =>
    (
      umiRequest as unknown as <R = unknown>(
        requestUrl: string,
        requestOptions?: ScopedRequestOptions,
      ) => Promise<R>
    )<T>(url, {
      baseURL: scopedBaseURL,
      ...(options || {}),
    });
};

export const createAppRequest = () => createRequest(BizAppConfig.appApiUrl);
export const createTenantManagementRequest = () =>
  createRequest(BizAppConfig.appTenantManagementUrl);
